import config from './../../config.js';
import Dialog_class from './../../libs/popup.js';

class Help_about_class {

	constructor() {
		this.POP = new Dialog_class();
	}

	//about
	about() 
	{
		var email = 'www.viliusl@gmail.com';	
		var email2 = 'support@sebreakstudio.com';
		const VERSION = "0.0.1";
		var settings = {
			title: 'About',
			params: [
				{title: "", html: '<img style="width:64px;" class="Logo" alt="" src="images/logo.png" />'},
				{title: "Name:", html: '<span class="about-name">AdSiege Generator</span>'},
				{title: "Version:", value: VERSION},
				{title: "Description:", value: "Online version of AdSiege Generator image editor."},
				{title: "Author:", value: 'ViliusL'},
				{title: "Email:", html: '<a href="mailto:' + email + '">' + email + '</a>'},
				{title: "GitHub:", html: '<a href="https://github.com/viliusle/miniPaint">https://github.com/viliusle/miniPaint</a>'},
				{title: "Author:", value: 'SiegeBreak Studio LLC'},
				{title: "Email:", html: '<a href="mailto:' + email2 + '">' + email2 + '</a>'},
				{title: "Website:", html: '<a href="https://sebreakstudio.com/software">https://sebreakstudio.com/software</a>'},
				
			],
		};
		this.POP.show(settings);
	}

}

export default Help_about_class;
